// extracted by mini-css-extract-plugin
export default {"review_sales_page":"styles_review_sales_page__7bm+j","brand_model":"styles_brand_model__C5aKQ"};